import React from 'react';
import { GameSession } from '../types';

interface ScoreBoardProps {
  session: GameSession;
}

export const ScoreBoard: React.FC<ScoreBoardProps> = ({ session }) => {
  const currentTime = session.endTime || Date.now();
  const elapsedTime = Math.floor((currentTime - session.startTime) / 1000);
  const minutes = Math.floor(elapsedTime / 60);
  const seconds = elapsedTime % 60;
  
  const progress = (session.currentQuestionIndex / session.questions.length) * 100;
  
  return (
    <div className="scoreboard">
      <div className="score-item">
        <span className="label">スコア:</span>
        <span className="value">{session.score}/{session.questions.length}</span>
      </div>
      
      <div className="score-item">
        <span className="label">問題:</span>
        <span className="value">{session.currentQuestionIndex}/{session.questions.length}</span>
      </div>
      
      <div className="score-item">
        <span className="label">時間:</span>
        <span className="value">{minutes}:{seconds.toString().padStart(2, '0')}</span>
      </div>
      
      <div className="progress-bar">
        <div 
          className="progress-fill" 
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};